// extracted by mini-css-extract-plugin
export default {"row":"OfferDayChips_row__hPXxZ","chip":"OfferDayChips_chip__TPa0o","chipOn":"OfferDayChips_chipOn__LT3zk"};